import { useIntl } from 'react-intl';

export function DocumentTitle() {
    const { formatMessage } = useIntl();
    document.title = formatMessage({ id: 'general.title', defaultMessage: "Leo's Kalasbokning" });
    return null;
}
